export const en = {
  controls: {
    shareLink: "Copy conference link",
    linkCopied: "Link copied, share it",
    shareModalTitle: "Conference link",
    shareModalDescription: "Copy the link to join the conference and send it to participants",
    shareModalCopy: "Copy link",
    shareModalShare: "Share",
    fullscreenEnter: "Enter fullscreen",
    fullscreenExit: "Exit fullscreen",
    screenShare: "Share screen",
    screenUnshare: "Stop sharing",
    cameraOn: "Turn off camera",
    cameraOff: "Turn on camera",
    micOn: "Turn off microphone",
    micOff: "Turn on microphone",
    settings: "Settings",
    exitConference: "Leave conference",
    exitConfirm: "Leave the conference?",
    exitYes: "Leave",
    exitNo: "Cancel",
    cameraLocked: "Camera locked — click to set up",
    micLocked: "Microphone locked — click to set up",
    selectMicrophone: "Select microphone",
    selectCamera: "Select camera",
    playbackOn: "Sound on",
    playbackOff: "Sound off",
    startRecording: "Start audio recording",
    stopRecording: "Stop recording",
    openSettings: "Open settings",
    closeSettings: "Close settings",
    toolbar: "Conference controls"
  },
  m: {
    appName: "YourTeams",
    appTagline: "Video conferencing without limits",
    createConference: "Create conference",
    rejoinConference: "Rejoin conference",
  },
  profile: {
    editName: "Edit name",
    welcome: "Welcome to YourTeams",
    enterNamePrompt: "Enter your name",
    continue: "Continue",
    close: "Close"
  },
  onboarding: {
    setupTitle: "Camera and microphone setup",
    permissionTitle: "Allow access",
    permissionDescription: "To participate in video calls, we need access to your camera and microphone",
    permissionHint: "Click the button below, then allow access in the browser popup",
    requestAccess: "Request access",
    continue: "Continue",
    selectDevices: "Select your camera and microphone for the call",
    joinWithoutCameraAndMic: "Continue without camera and microphone",
    joinWithoutCamera: "Continue without camera",
    joinWithoutMic: "Continue without microphone"
  },
  preferences: {
    title: "Settings",
    enterYourName: "Enter your name",
    enterYourNameLong: "Enter your name to join the conference",
    errorNameMustBeNotEmpty: "Name cannot be empty",
    errorNameMustNotTooLongBegin: "Name cannot be longer",
    errorNameMustNotTooLongEnd: "characters",
    errorAllowOnlyLettersAndSpaces: "Only letters, digits and spaces are allowed",
    cameraLabel: "Camera",
    microphoneLabel: "Microphone",
    cameraLoading: "Loading camera...",
    noCameras: "No cameras found",
    noMicrophones: "No microphones found",
    defaultCameraName: "Camera {index}",
    defaultMicrophoneName: "Microphone {index}",
    micTestButton: "Test microphone",
    micTestStopButton: "Stop recording",
    micTestStopPlaybackButton: "Stop playback",
    micTestSpeak: "Speak, recording in progress.",
    micTestPlayback: "Playing back",
    micTestNoAudio: "No microphone detected",
    micTestNotSupported: "Microphone test is not supported in this browser",
    micTestProgressHint: "0 — {seconds}s",
    speakerLabel: "Speaker",
    defaultSpeakerName: "Speaker {index}",
    speakerTestButton: "Test speaker"
  },
  access: {
    error: 'No access to camera/microphone',
    request: 'Request access',
    suggest: 'If the access request key does not work, check if there is a restriction in your browser settings. After changing the settings, it is recommended to restart the browser and re-enter the site.'
  },
  settings: {
    videoTab: "Video",
    audioTab: "Audio",
    moreTab: "More",
    debugInfo: "Debug info",
    debugInfoDescription: "Show connection state on video tiles",
    jitterBuffer: "Jitter buffer",
    jitterBufferDescription: "Increase buffer to reduce frame drops on unstable connections",
    virtualBackground: "Virtual background",
    comingSoon: "soon",
    recordingTab: "Recording",
    autoRecordOnPeerJoin: "Start recording when someone joins",
    autoRecordOnPeerJoinDescription: "Recording starts automatically when someone else enters the room. If you turn recording off, it won't start again on its own; you can stop recording at any time. Recording does not stop when a participant leaves.",
    autoRecordFailed: "Couldn't start recording automatically",
  },
  videoElement: {
    cameraOff: "Camera off",
    micOff: "Microphone off",
    ok: "OK",
    cancel: "Cancel",
    screenShare: "Screen share",
    stopSharing: "Stop screen sharing"
  },
  prejoin: {
    title: "Join conference",
    cancel: "Cancel",
    joinButton: "Join conference",
    updating: "Updating…",
    joinWithoutMedia: "Join without camera and microphone",
    cameraOn: "Camera on",
    cameraOff: "Camera off",
    micOn: "Microphone on",
    micOff: "Microphone off",
    cameraDisabled: "Camera off",
    cameraUnavailable: "Camera unavailable",
    micDisabled: "Microphone off",
    micUnavailable: "Microphone unavailable",
    micLevel: "Microphone level",
    enterNameHint: "Enter your name to join",
    selectCamera: "Select camera",
    selectMic: "Select microphone",
    selectSpeaker: "Select speaker",
    mediaAccessNeeded: "Camera and microphone access is needed for the video call",
    enableCameraAndMic: "Enable camera and microphone",
    mediaAccessHint: "To be seen and heard, we need access to your camera and microphone. Click the button — the browser will ask for permission",
  },
  permissions: {
    promptTitle: 'Camera and microphone access required',
    promptDescription: 'To make calls, allow access to your camera and microphone',
    openSettings: 'Open Settings',
    configure: 'Configure',
    deniedTitle: 'Access to camera and microphone denied',
    deniedDescription: 'Allow access in your browser settings to participate in calls',
    retryCheck: 'I allowed — check again',
    cameraUnavailable: 'Camera unavailable',
    microphoneUnavailable: 'Microphone unavailable',
    requestCameraAccess: 'Allow camera access',
    requestMicAccess: 'Allow microphone access',
    instructionsChrome: 'Click the 🔒 icon to the left of the address bar → Site settings → Camera/Microphone → Allow',
    instructionsFirefox: 'Click the 🔒 icon to the left of the address bar → Permissions → Camera/Microphone',
    instructionsSafari: 'Safari → Settings → Websites → Camera/Microphone → Allow',
    instructionsDefault: 'Open browser settings and allow access to camera and microphone for this site'
  },
  errors: {
    mediaAccessDenied: 'Camera/microphone access denied. Check browser permissions.',
    mediaNotFound: 'No camera or microphone found.',
    mediaOverconstrained: 'Selected device is no longer available.',
    deviceBusy: 'Device is being used by another application. Close other apps using camera or microphone.',
    mediaAccessFailed: 'Failed to access camera/microphone.',
    recordingFailed: 'Recording is already running in another browser tab or window.',
    copyFailed: 'Failed to copy the link. Copy it manually from the address bar.',
    cameraSwitchFailed: 'Failed to switch the camera.',
  },
  recordings: {
    quotaUsed: '{usage} MB of {quota} MB',
    quotaWarning: 'Storage is almost full — delete old recordings',
    lowSpace: 'Low browser storage — old recordings may not be saved',
    export: 'Export',
    fragmentSize: '{size} MB',
    delete: 'Delete',
    recordingNow: 'recording',
    title: 'Recordings',
    close: 'Close',
    empty: 'No recordings yet',
    confirmDelete: 'Delete this file?',
    localNotice: 'Stored locally in this browser and may be cleared by the browser. This is not the cloud.',
    openHistory: 'Recordings history',
    closeHistory: 'Close recordings history',
  },
  profileSection: {
    title: 'Profile',
    namePlaceholder: 'Your name',
    savedHint: 'Saved',
  },
  menu: {
    title: 'Settings',
  },
  observation: {
    title: 'Observation mode',
    description: 'This device will keep the room open. The screen stays dark while nobody is here; the camera turns on as soon as a participant joins.',
    arm: 'Start observing',
    waiting: 'Observing · waiting for participants',
  },
  invite: {
    title: 'You\'ve been invited to a conference',
    enter: 'Join',
    cancel: 'Cancel',
  },
}
